import React from 'react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';

const CapitalBeauty = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = translations[language].common;

  return (
    <section className="relative h-[80vh] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(/assets/images/homepage/capital-beauty.jpeg)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 to-transparent" />
      </div>

      <div className="relative h-full flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            {language === 'en' ? (
              <>
                <h2 className="text-6xl md:text-7xl font-bold text-white mb-4 tracking-wider">
                  CAPITAL BEAUTY
                </h2>
                <h3 className="text-5xl md:text-6xl font-bold text-red-600 mb-8">
                  REDEFINED
                </h3>
              </>
            ) : (
              <h2 className="text-4xl md:text-6xl font-bold text-white mb-8 leading-tight">
                <span className="block mb-2 text-white">إعادة تعريف الأناقة الحضرية</span>
                <span className="text-red-600">بمعايير تصميم متطورة.</span>
              </h2>
            )}
          </div>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="absolute bottom-0 right-0 w-1/3 h-2/3 opacity-20">
        <div className="absolute inset-0 bg-gradient-to-tl from-red-600/30 to-transparent blur-3xl" />
      </div>
    </section>
  );
};

export default CapitalBeauty;